import store from '@/store';
import hasPermission from '@/utils/hasPermission';
import hasGeneralPermission from '@/utils/hasGeneralPermission';

export default async (to, from, next, genPermissionCheck) => {
  let hasCorrectPermission = false;
  let hasCorrectGenPermission = false;
  const { me } = store.state.users;

  if (!me?.id) {
    const meUser = await store.dispatch('users/me');
  }

  hasCorrectGenPermission = store.state?.users?.me
    ? hasGeneralPermission(store.state?.users?.me, to.meta?.requiresPermission)
    : false;

  hasCorrectPermission = store.state?.users?.me
    ? hasPermission(store.state?.users?.me, to?.meta?.requiresPermission)
    : false;

  if (to?.meta?.requiresPermission?.length > 0) {
    if (genPermissionCheck && hasCorrectGenPermission) {
      next();
      return;
    }

    if (!genPermissionCheck && hasCorrectPermission) {
      next();
      return;
    }

    next('/not-authorized');
  }
};
